import type { QueryClient } from "react-query";
import { useOrdersKanbanStore } from "../stores/kanban.store";

export const resetAuthSessionState = (queryClient: QueryClient) => {
	queryClient.clear();
	useOrdersKanbanStore.getState().resetSessionState();
};
